import { RootState } from '@/types/Store';
const state = (): RootState => ({ loading: false, memberVisible: true });

export default state;
